import { type Component, Show } from "solid-js";
import { type RouteSectionProps, useNavigate } from "@solidjs/router";
import { isNil } from "lodash-es";
import { useLocalUserSettings } from "../state/localUserSettings";
import type CustomerId from "../state/CustomerId";
import ApiService from "../services/ApiService";

const HomePage: Component<RouteSectionProps<never>> = () => {
  const navigate = useNavigate();
  const { lastCustomerId } = useLocalUserSettings();
  const customersQuery = ApiService.getCustomers();

  const navigateToCustomer = (customerId: CustomerId) => {
    navigate(`/customers/${customerId}`, { replace: true });
  };

  return (
    <Show when={customersQuery.data}>
      {(customers) => {
        const firstCustomerId = customers().at(0)?.customerId;
        if (isNil(firstCustomerId)) {
          // Theoretically, a user can have access to no customer at all. But these cases are very rare, for now a
          // simple message will suffice.
          return <div>No customer found</div>;
        }

        // Navigate to last accessed customer if user still has access to it, otherwise to the first customer it has access to
        if (!isNil(lastCustomerId) && customers().some(({ customerId }) => customerId.equals(lastCustomerId))) {
          navigateToCustomer(lastCustomerId);
        } else {
          navigateToCustomer(firstCustomerId);
        }
      }}
    </Show>
  );
};
export default HomePage;
